import { render, staticRenderFns } from "./DkVideoModal.vue?vue&type=template&id=7983b140&"
import script from "./DkVideoModal.vue?vue&type=script&lang=js&"
export * from "./DkVideoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports